import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn,
  formatDate,
  Textarea,
  FormRow,
  FormGroup,
  Label,
  Input,
  Select
} from '../styles/PageStyles';
import { faKeyboard } from '@fortawesome/free-solid-svg-icons';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import {  createPrompt, getPrompts,  updatePrompt } from '../services/promptService';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toastService from '../services/toastService';

const PromptLibraryDetails = () => {
  const navigate = useNavigate()
  const { promptId } = useParams();
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('prompts');
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [promptList, setPromptList] = useState([null]);
  const [promptTemplateList, setPromptTemplateList] = useState([null]);

  const initialPrompt = {
    "code": "PRM-" + new Date().getTime(),
    "company_cd": "",
    "name": "",
    "description": "",
    "version": "1",
    "usage": "Medium",
    "performance": 90,
    "status": "ACTIVE",
    "category": "Customer Service",
    "template": "",
    "is_template":true,
    "created_by":""
  }
  useEffect(() => {
    const fetchPrompts = async () => {
      try {
        let filter = {
          code: promptId
        }
        const response = await getPrompts(filter);
        setSelectedPrompt(response[0]);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    if (promptId != 'new') {
      fetchPrompts();
    } else {
      if(user){
      initialPrompt.company_cd = user.companyCd;
      initialPrompt.created_by = user.username;
      setSelectedPrompt(initialPrompt)
      }
    }

  }, [promptId, user])
  // Filter prompts based on search term
  const filteredPrompts = promptList.filter(prompt =>
    prompt?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    prompt?.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    prompt?.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'active';
      case 'draft': return 'default';
      case 'deprecated': return 'warning';
      default: return 'default';
    }
  };

  // Get usage badge color
  const getUsageColor = (usage) => {
    switch (usage) {
      case 'Very High': return 'error';
      case 'High': return 'warning';
      case 'Medium': return 'active';
      case 'Low': return 'default';
      default: return 'default';
    }
  };

  // Handle prompt selection
  const savePrompt = async () => {
    if (selectedPrompt.id) {
      try {
        const updatePromptResponse = updatePrompt(selectedPrompt)
        toastService.success("Prompt Updated Successfully")
        navigate("/prompt-library")
      } catch (error) {
        toastService.error("Error in Prompt Update")
      }
    } else {
      try {
        
        const createPromptResponse = createPrompt(selectedPrompt)
        toastService.success("Prompt Created Successfully")
        navigate("/prompt-library")
      } catch (error) {
        toastService.error("Error in Prompt Creation")
        
      }
    }
  };
  const updateSelectedAgent = (path, value) => {
    setSelectedPrompt((prev) => {
      const updatedPrompt = { ...prev }; // Create a shallow copy of selectedAgent
      const keys = path.split('.'); // Split the path into keys (e.g., "object.key" -> ["object", "key"])

      let current = updatedPrompt; // Start at the root of the object

      keys.forEach((key, index) => {
        if (key.includes('[')) {
          // Handle array indexing, e.g., "array[0].key"
          const [arrayKey, arrayIndex] = key.match(/([^\[\]]+)|(\d+)/g); // Extract array name and index
          if (index === keys.length - 1) {
            // If it's the last key, update the value
            current[arrayKey][parseInt(arrayIndex, 10)] = {
              ...current[arrayKey][parseInt(arrayIndex, 10)],
              [keys[index + 1]]: value,
            };
          } else {
            current = current[arrayKey][parseInt(arrayIndex, 10)];
          }
        } else if (index === keys.length - 1) {
          // If it's the last key, update the value
          current[key] = value;
        } else {
          // Otherwise, move deeper into the object
          current = current[key];
        }
      });
      // console.log(updatedPrompt)
      return updatedPrompt;
    });
  };
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faKeyboard}
          goBack={true}
          title={selectedPrompt?.name ? selectedPrompt?.name : "Add Prompt"}
          description="Manage, version, and optimize prompts used by AI agents across the system.
          Create templates, track performance, and ensure consistency in AI interactions."
        >
          {/* <div style={{ display: 'flex', gap: '1rem' }}>
            <SearchInput
              type="text"
              placeholder="Search prompts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button>Import Prompts</Button>
            <Button primary>Create Prompt</Button>
          </div> */}
        </PageHeaderWithInfo>

        <Card>
          {selectedPrompt ? (
            <CardContent>
              <div style={{ marginBottom: '1rem' }}>
                <FormRow>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input type='text' value={selectedPrompt.name} onChange={(e) => { updateSelectedAgent("name", e.target.value) }} />
                  </FormGroup>
                  <FormGroup>
                    <Label>Category</Label>
                    <Select value={selectedPrompt.category} onChange={(e) => { updateSelectedAgent("category", e.target.category) }}>
                      <option value="">Select Category</option>
                      <option value="Claims">Claims</option>
                      <option value="Underwriting">Underwriting</option>
                      <option value="Customer Service">Customer Service</option>
                      <option value="Fraud">Fraud</option>
                      <option value="Document Processing">Document Processing</option>
                    </Select>
                  </FormGroup>
                </FormRow>
                <FormRow>
                  <FormGroup>
                    <Label>Version</Label>
                    {selectedPrompt?.version}
                  </FormGroup>
                  <FormGroup>
                    <Label>Author</Label>
                    {selectedPrompt?.created_by}
                  </FormGroup>
                </FormRow>
                {/* <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>{selectedPrompt?.name}</h3>
                <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>{selectedPrompt?.description}</p>

                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                  <div>
                    <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Category</div>
                    <div>{selectedPrompt?.category}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Version</div>
                    <div>{selectedPrompt?.version}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Author</div>
                    <div>{selectedPrompt?.author}</div>
                  </div>
                </div> */}

                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Prompt Template</div>
                  <Textarea rows="20" style={{
                    background: '#fff',
                    padding: '1rem',
                    borderRadius: '8px',
                    fontFamily: 'monospace',
                    fontSize: '0.9rem',
                    whiteSpace: 'pre-wrap',
                    maxHeight: '300px',
                    overflowY: 'auto'
                  }}
                  onChange={(e) => { updateSelectedAgent("prompt", e.target.value) }}>

                    {selectedPrompt?.prompt}
                  </Textarea>
                </div>

                <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                  <Button>Test Prompt</Button>
                  <Button>View History</Button>
                  <Button primary onClick={(e) => { savePrompt() }}>Save Changes</Button>
                </div>
              </div>
            </CardContent>
          ) : (
            <CardContent>
              <div style={{
                height: '300px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '1rem',
                color: 'var(--text-secondary)'
              }}>
                <div style={{ fontSize: '3rem' }}>⌕</div>
                <div>Select a prompt to view details</div>
              </div>
            </CardContent>
          )}
        </Card>

        <Card style={{ marginTop: '2rem' }}>
          <CardContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem', flexWrap: 'wrap', gap: '1rem' }}>
              <div style={{ flex: '1 1 30%', minWidth: '250px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Structure</div>
                <ul style={{ paddingLeft: '1.5rem', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                  <li>Use clear sections with headers</li>
                  <li>Include specific instructions at the beginning</li>
                  <li>Use numbered lists for multi-step tasks</li>
                  <li>Include placeholders for dynamic content</li>
                  <li>End with expected output format</li>
                </ul>
              </div>

              <div style={{ flex: '1 1 30%', minWidth: '250px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Clarity</div>
                <ul style={{ paddingLeft: '1.5rem', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                  <li>Be specific about the desired outcome</li>
                  <li>Define technical terms when necessary</li>
                  <li>Use consistent terminology throughout</li>
                  <li>Avoid ambiguous instructions</li>
                  <li>Provide examples for complex tasks</li>
                </ul>
              </div>

              <div style={{ flex: '1 1 30%', minWidth: '250px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Optimization</div>
                <ul style={{ paddingLeft: '1.5rem', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                  <li>Test prompts with various inputs</li>
                  <li>Track performance metrics</li>
                  <li>Version control all changes</li>
                  <li>Optimize for token efficiency</li>
                  <li>Regularly review and update</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </PageContainer>
  );
};

export default PromptLibraryDetails;
